import React, { FC, useEffect } from 'react';
import { Snack, Snackbar, useSnackbar } from 'fronton-react';
import { CheckCircleIcon } from '@fronton/icons-react';

export const SHOW_COPY_SNACK = 'SHOW_COPY_SNACK';

export const AddressCopySnack: FC = () => {
  const { state, addSnack } = useSnackbar();

  useEffect(() => {
    const showShack = () => addSnack({ id: String(new Date().valueOf()) });

    document.addEventListener(SHOW_COPY_SNACK, showShack);

    return () => {
      document.removeEventListener(SHOW_COPY_SNACK, showShack, false);
    };
  });

  return (
    <Snackbar>
      {state.map(({ id }) => (
        <Snack
          key={id}
          id={id}
          paragraph="Адрес скопирован"
          icon={<CheckCircleIcon type="outline" size="l" color="text-invert" />}
          autoHideTimer={3000}
        />
      ))}
    </Snackbar>
  );
};
